import clsx from 'clsx'
import { useId } from 'react'
import { Checkbox } from '@/components/ui/checkbox'

type CheckboxProps = {
  label?: string
  checked?: boolean
  className?: string
  onCheckedChange?: (value: boolean) => void
  children?: React.ReactNode
  disabled?: boolean
}

const CustomCheckbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  className,
  onCheckedChange,
  children,
  disabled,
}) => {
  // Usar useId para gerar ID estável entre server e client
  const id = useId()

  return (
    <div className={clsx('flex items-center space-x-2', className)}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={value => onCheckedChange?.(!!value)}
        disabled={disabled}
        className="border-[var(--foreground-300)] cursor-pointer"
      />

      <label
        htmlFor={id}
        className="text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-neutral-400 cursor-pointer"
      >
        {label || children}
      </label>
    </div>
  )
}

export default CustomCheckbox
